
import { useEffect, useRef, useState } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navigation from '../../components/feature/Navigation';

export default function Home() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative bg-white overflow-hidden">
      <Navigation />
      <Hero scrollY={scrollY} />
      <Services scrollY={scrollY} />
      <About scrollY={scrollY} />
      <Contact />
      <Footer />
    </div>
  );
}
